export default "__VITE_ASSET__DWePzdNl__"